import {defineStore} from "pinia/dist/pinia";

export const useDraftStore = defineStore('draft-store', {
    state: () => ({
        title: null,
        loading: false,

        loadedDrafts: null,
        selectedDraft: null,
        page: 1,
        lastPage: 1,
    }),
});
